import r from"react";let a=function(t){let e=r.useRef(t);return e.current=t,r.useCallback((...u)=>e.current(...u),[e])};export{a as useEvent};
